import React, { useEffect, useState } from 'react'

import { withTranslation } from 'react-i18next'
import { gql } from '@apollo/client'
import {
    Button,
    Box,
    Card,
    Grid,
    Typography
} from '@material-ui/core'

import InfoIcon from '@material-ui/icons/Info'

import {Loading} from '../../components/Loading/Loading'
import UserBayphoneTable from './UserBayphoneTable'
import UpcomingBayphones from './UpcomingBayphones'
import ActiveBayphones from './ActiveBayphones'

const query = gql`
    query {
        myBayphones {
            activeBayphones {
                id
                deviceType {
                    id
                    name
                }
                state {
                    id
                    name
                }
                changeReason {
                    name
                }
                claimedAmount
                approvedAmount
                termsPolicy
                termsFile
                observation
                createdAt
                expirationDate
            }
            companyBayphone {
                id
                infoLink
                currency {
                    code
                    symbol
                }
            }
            userBayphone {
                id
                isActive
                user {
                    firstName
                    middleName
                    lastName
                    email
                }
            }
            upcomingBayphones {
                deviceType {
                    name
                }
                validSince
            }
        }
    }
`

const UserBayphoneComponent = (props) => {
    const { data, handleRefresh, t } = props

    const [activeBayphones, setActiveBayphones] = useState([])
    const [upcomingBayphones, setUpcomingBayphones] = useState([])

    useEffect(() => {
        if (data) {
            setActiveBayphones(data.myBayphones.activeBayphones)
            setUpcomingBayphones(data.myBayphones.upcomingBayphones)
        }
    }, [data])

    return (
        <Card id='bayphones_detail' style={{ marginTop: 10 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Typography 
                        variant="h6" 
                        style={{ paddingLeft: 10, marginBottom: 8 }}
                    >
                        <b>{t('Active')}</b>
                    </Typography>
                    {activeBayphones.map((active, index) => (
                        <ActiveBayphones
                            key={index}
                            index={index}
                            bayphone={active}
                            t={t}
                            handleRefresh={handleRefresh}
                        />
                    ))}
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography 
                        variant="h6" 
                        style={{ paddingLeft: 10, marginBottom: 8 }}
                    >
                            <b>{t('Upcoming')}</b>
                    </Typography>
                    {upcomingBayphones.map((upcoming, index) => (
                        <UpcomingBayphones
                            key={index}
                            index={index}
                            upcoming={upcoming}
                            t={t}
                        />
                    ))}
                </Grid>
            </Grid>
        </Card>
    )
}

const MyBayphone = (props) => {
    const { t } = props

    const [refreshKey, setRefreshKey] = useState(0)

    document.title = `${props.t('root:My Bayphone')} - BubbleBPM`

    const handleRefresh = () => setRefreshKey(prev => prev + 1)
    const info = {}

    return (
        <div id="mybayphone">
            <Loading key={refreshKey} query={query} showLoading={false}>
                {(data) => {
                    return (
                        <>
                            <Card style={{ marginTop: 5, marginBottom: 10, padding: 8 }}>
                                <Box display="flex" alignItems="center" justifyContent="space-between">
                                    <Typography variant="h5">
                                        { t('My Bayphones') }
                                    </Typography>
                                    { data && data.myBayphones.companyBayphone.infoLink ?
                                        <a
                                            href={ data.myBayphones.companyBayphone.infoLink }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <Button size="small">
                                                <InfoIcon />
                                            </Button>
                                        </a>
                                    : null }
                                </Box>
                            </Card>
                            <UserBayphoneComponent
                                data={data}
                                t={t}
                                handleRefresh={handleRefresh}
                            />

                            <div id='user_bayphone_table' style={{ position: "relative", paddingTop: 10}}>
                                <UserBayphoneTable
                                    filters={{filterUserBayphones: true}} 
                                />
                            </div>
                        </>
                    )
                }}
            </Loading>
        </div>
    )
}

export default withTranslation('bayphone')(MyBayphone)

